class DepartmentFilter {

  constructor(element) {
    this.element = element
    this.init()
    this.listen()
  }

  init() {
    const target = window.location.hash.replace('#', '')
    const active_button = document.querySelector('[data-target="all"]')
    if (target && document.querySelector(`[data-department="${target}"]`)) {
      const new_button = this.element.querySelector(`.button--tag[data-target="${target}"]`)
      active_button.classList.remove('active')
      new_button.classList.add('active')
      // skjul alle
      document.querySelectorAll('[data-department]').forEach(el => el.classList.add('hidden'))
      // vis den som skal være åpen
      document.querySelector(`[data-department="${target}"]`).classList.remove('hidden')
      this.element.scrollIntoView()
    }
  }

  listen() {
    this.element.addEventListener('click', (ev) => {
      const target = ev.target.getAttribute('data-target')
      if (ev.target.classList.contains('button--tag')) {
        if (ev.target.classList.contains('active')) return
        const active_button = this.element.querySelector('.button--tag.active')
        if (target == "all") {
          // vis alle
          active_button.classList.remove('active')
          const new_button = this.element.querySelector('[data-target="all"]')
          new_button.classList.add('active')
          document.querySelectorAll('[data-department]').forEach(el => el.classList.add('hidden'))
          setTimeout(() => {
            document.querySelectorAll('[data-department]').forEach(el => el.classList.remove('hidden'))
          }, 20)
        } else {
          const new_button = this.element.querySelector(`.button--tag[data-target="${target}"]`)
          active_button.classList.remove('active')
          new_button.classList.add('active')
          // skjul alle
          document.querySelectorAll('[data-department]').forEach(el => el.classList.add('hidden'))
          // vis den ene som skal være åpen
          setTimeout(() => {
            document.querySelector(`[data-department="${target}"]`).classList.remove('hidden')
          }, 20)
        }
      }
    })
  }

}

export default DepartmentFilter